export default new class JournalDropdown {
  constructor() {
    this.dropdownInit = 'js-dropdown-journal-init';
    this.journalDropdownAttribute = 'data-journal-dropdown';
    this.journalDataAjaxRequest = 'JournalData::onAjaxRequest';

    this.initBindings();
  }

  initBindings() {
    $(document).on('touchstart click', '[data-journal-dropdown]', (e) => {
      const $target = $(e.currentTarget);
      const sSubJournal = $target.attr('data-zhurnal');

      // Get new journal data
      if ($target.parents('._journal_number_list').length > 0) {
        const iJournalID = $target.attr(this.journalDropdownAttribute);

        $.request(this.journalDataAjaxRequest, {
          data: {
            journal_id: iJournalID,
            subjournal: sSubJournal,
          },
          update: {
            'project/common/modal-journal-content/modal-journal-content': '.modal-journal-content',
          },
        });
      } else if ($target.parents('._journal_year_list').length > 0) {
        const sJournalName = $('._journal_number_list ._active').html();


        const iYear = $target.attr(this.journalDropdownAttribute);

        $.request(this.journalDataAjaxRequest, {
          data: {
            year: iYear,
            journal_name: sJournalName,
            subjournal: sSubJournal,
          },
          update: {
            'project/common/modal-journal-content/modal-journal-content': '.modal-journal-content',
          },
        });
      } else if ($target.parents('._journal_archive').length > 0) {
        const iYear = $target.attr(this.journalDropdownAttribute);

        $.request(this.journalDataAjaxRequest, {
          data: {
            year: iYear,
            subjournal: sSubJournal,
          },
          update: {
            'project/common/modal-journal-archive/modal-journal-archive': '.modal-journal-archive',
          },
        });
      }
    });
  }
}();
